// extracted by mini-css-extract-plugin
module.exports = {"reviewItemsWrapper":"XK","showItemsBtn":"YK","disabled":"ZK"};